export const getLocalUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};
